// Libraries
import React, { Suspense } from 'react';
import { CssBaseline } from '@mui/material';
import { createTheme, ThemeProvider} from '@mui/material/styles';

// Assets
import '../assets/css/global.css';
import '../assets/css/scrollbar.css';

// Layouts
import { Core as IndexCore } from './Core';

import { Box } from '@mui/system';
import { Logo } from '../core/global/Icons';
import { SnakeLoader } from '../core/loader/SnakeLoader';
import { ToolProvider } from '../core/context/ToolContext';

export const Index = () => {
    const pageTheme = createTheme({
        breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 900,
                lg: 1200,
                xl: 1536,
                mobile: 0,
                tablet: 768,
                desktop: 1025,
            },
        },
        palette: {
            background: {
                default: '#f3f6fd'
            },
            primary: {
                main: '#E56910',
                dark: '#E56910',
                light: '#e9ebee',
                lighter: '#f8f9fa',
            },
            secondary: {
                main: '#002016',
                dark: '#002016',
                light: '#ffffff',
            },
            info: {
                main: '#005AA3',
                dark: '#005AA3',
                light: '#b8d4d2',
            },
            error: {
                main: '#f44336',
                light: '#f6685e',
                dark: '#d32f2f'
            },
            warning: {
                main: '#ff9800',
                dark: '#b26a00',
                light: '#ffac33'
            },
            success: {
                main: '#4caf50',
                dark: '#388e3c',
                light: '#81c784'
            },
        },
        typography: {
            button: {
                textTransform: 'none'
            },
            fontFamily: [
              '-apple-system',
              '"Inter"',
            ].join(','),
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        fontSize: '14px',
                        boxShadow: 'none',
                        "&:hover" : {
                            boxShadow: 'none',
                        }
                    }
                },
            },
            MuiOutlinedInput: {
                styleOverrides: {
                    root: {
                        borderRadius: '8px',
                        borderColor: '#C6CEDE',
                        "&:hover" : {
                            borderColor: '#C6CEDE',
                        }
                    }
                },
            }
        }
    });

    let Core
    Core = IndexCore
    return (
        <ThemeProvider theme= { pageTheme }>
			<CssBaseline />
                <ToolProvider platform="business">
                    <Suspense fallback={
                        <Box height="100%" width="100%" display="flex" flexDirection="column" justifyContent="center" alignItems="center">
                            <Logo size={60}/>
                            <Box mt={4}>
                                <SnakeLoader size="1rem" bg="#0070EF" distance="0.3rem" />
                            </Box>
                        </Box>
                    }>
                        <Core />
                    </Suspense>
                </ToolProvider>
		</ThemeProvider>
    )
}